import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'components/UIElements'
import STRINGS from 'utils/strings'
import '../stylesheets/visitTemplatePage.scss'
import VisitsFields from './VisitFields'
import { MODAL_BUTTONS_MAP, MODAL_CLASSES_MAP, MODAL_CONTENT_MAP, HOURS_IN_DAY } from 'utils/constants'

function VisitTemplatePage(props) {
  const {
    isVisitTemplateEditor,
    subtitleName,
    visitTemplate,
    visitTemplateID,
    onSaveVisitTemplate,
    studyID,
    studyLock,
    isArmsSupported = false,
    openModal,
    onDeleteArm,
    isArmAllowedToDelete,
  } = props
  const { name: visitName } = visitTemplate || {}
  const [armInputError, setArmInputError] = useState('')

  const onOpenDeleteModal = () => {
    openModal({
      onConfirm: () => {
        onDeleteArm({ studyID, visitTemplateID })
      },
      cancelButton: MODAL_BUTTONS_MAP.cancel,
      className: MODAL_CLASSES_MAP.spacious,
      confirmButton: MODAL_BUTTONS_MAP.confirm,
      content: STRINGS.deleteArmConfirm,
      heading: MODAL_CONTENT_MAP.pleaseConfirm,
      isUrgent: true,
    })
  }

  return (
    <div className='visits-template-page page'>
      <div className='flexed'>
        <h4>{subtitleName}</h4>
        {/* <Button id='top-save-as-draft' grey content='Save as Draft' onClick={() => {}} /> */}
      </div>
      <VisitsFields {...props} armInputError={armInputError} setArmInputError={setArmInputError} />
      <div className='button-list'>
        {/* <Button grey id='bottom-save-as-draft' content='Save as Draft' onClick={() => {}} /> */}
        <Button
          disabled={!visitName || studyLock || !!armInputError}
          id='next'
          className='deploy-button'
          content={isArmsSupported ? STRINGS.saveArm : STRINGS.saveVisitSchedule}
          onClick={() => onSaveVisitTemplate({ studyID, isUpdate: isVisitTemplateEditor, visitTemplateID })}
        />
        {isVisitTemplateEditor && isArmsSupported && isArmAllowedToDelete ? (
          <Button
            red
            disabled={studyLock}
            id='delete-arm'
            isThrottled
            content={STRINGS.deleteArm}
            onClick={onOpenDeleteModal}
          />
        ) : null}
      </div>
    </div>
  )
}

VisitTemplatePage.propTypes = {
  onSaveVisitTemplate: PropTypes.func,
  studyID: PropTypes.number,
  visitTemplateID: PropTypes.string,
}

export default VisitTemplatePage
